import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  color: #555555;

  @media screen and (max-width: 960px) {
    overflow-y: auto;
  }
`;

export const FormSide = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 2rem;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 430px;
  display: flex;
  flex-direction: column;

  .error {
    color: var(--error);
    font-size: 13px;
  }

  .success {
    color: var(--success);
    font-size: 13px;
  }

  .imgDiv {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 2rem;
    img {
      object-fit: cover;
      width: 180px;
      height: auto;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-bottom: 1.5rem;
    font-size: 15px;
    color: #6b7280;

    .Entrar {
      font-weight: 800;
      font-size: 1.8rem;
      color: #111827;
    }
  }

  input {
    width: 100%;
    padding: 12px 14px;
    font-size: 14px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e5ea !important;
    box-shadow: none !important;

    ::placeholder {
      font-size: 13px !important;
    }

    &:focus {
      outline: none !important;
      border-color: var(--blue-base) !important;
      box-shadow: 0 0 0 3px rgba(15, 87, 205, 0.15) !important;
    }
  }

  .forgot {
    font-weight: 500;
    font-size: 14px;
    margin-top: 1.2rem;
    color: #374151;

    span {
      color: var(--blue-base);
      padding: 0 4px;
      font-weight: 600;

      :hover {
        color: var(--blue-20);
        cursor: pointer;
      }
    }
  }
`;

export const Button = styled.button`
  margin-top: 1.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--blue-base);
  color: #fff;
  width: 100%;
  border: none;
  height: 44px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  span {
    font-size: 15px;
  }

  &:hover {
    background-color: var(--blue-20);
  }
`;

export const PositionSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BannerSide = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  background: linear-gradient(135deg, #0a3d8f 0%, #051f47 100%);
  color: #fff;
  position: relative;
  overflow: hidden;

  .content {
    max-width: 480px;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }

  .mockup {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
  }

  .mockup-dots {
    display: flex;
    gap: 6px;
    margin-bottom: 0.4rem;

    span {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.35);
    }
  }

  .mockup-bar {
    height: 14px;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.25);

    &.full {
      width: 100%;
    }

    &.medium {
      width: 75%;
    }

    &.small {
      width: 55%;
    }
  }

  .mockup-blocks {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    margin-top: 1rem;
    height: 90px;

    div {
      flex: 1;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.25);

      &:nth-child(1) {
        height: 45%;
      }
      &:nth-child(2) {
        height: 65%;
      }
      &:nth-child(3) {
        height: 100%;
      }
      &:nth-child(4) {
        height: 55%;
      }
      &:nth-child(5) {
        height: 80%;
      }
    }
  }

  blockquote {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
    padding-left: 1.2rem;
    border-left: 3px solid rgba(255, 255, 255, 0.6);
  }

  p {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`;
